import getSlugText from "../getSlugLabel";

/**
 * @param {object} params
 * @param {import("@raiden/library/types/Prestation").Prestation} params.prestation
 * @returns {string}
 */
export function getPrestationSlug({ prestation }) {
  return `${prestation.id}-${getSlugText(prestation.name)}`;
}
